import OliverText from "@builder/components/general/OliverText";
import SimpleCheckbox from "@builder/components/general/SimpleCheckbox";
import TextInput from "@builder/components/general/TextInput";
import { ActionEditorItem, updateStepperActions } from "@builder/store/slices/actionBuilderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { ActionType } from "@common/build/types";
import { useEffect, useState } from "react";

const AddCartDiscount = () => {
    const { id } = useAppSelector(state => state.actionBuilder.current);
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor.find(item => item.id === id));
    const [isFixed, setFixed] = useState(actionStep?.action?.data.isFixed || false);
    const [isPercent, setPercent] = useState<boolean>(actionStep?.action?.data.isPercent || false);
    const [discountLabel, setLabel] = useState<string>(actionStep?.action?.data.discountLabel || "");
    const [discountAmount, setAmount] = useState<string>(actionStep?.action?.data.discountAmount || "");
    const dispatch = useAppDispatch();

    const handleAmount = (value: string) => {
        if (isPercent) {
            if (/^\d*$/.test(value) && Number(value) >= 0 && Number(value) <= 100) {
                setAmount(value);
            }
        } else {
            if (/^\d*\.?\d{0,2}$/.test(value)) {
                setAmount(value);
            }
        }
    };

    const handleToggle = () => {
        setPercent(prev => !prev);
        setAmount("");
    };

    useEffect(() => {
        const data = isFixed ? { isPercent, discountAmount, discountLabel } : undefined;
        const action = {
            type: isFixed ? ActionType.CART_ADD_DISCOUNT : ActionType.CART_SHOW_DISCOUNT_UI,
            data: { isFixed, ...data }
        };

        const updatedStep = { ...actionStep };
        updatedStep.action = { ...action };

        if (JSON.stringify(updatedStep) !== JSON.stringify(actionStep)) {
            dispatch(updateStepperActions({ id: id as string, item: updatedStep as ActionEditorItem }));
        }
    }, [actionStep, dispatch, id, isFixed, isPercent, discountAmount, discountLabel]);

    return (
        <div className="function-add-cart-note-wrapper">
            <OliverText text="How do you want to add the discount?" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
            <div className="function-add-cart-note">
                <div className="function-checkbox-wrapper" onClick={() => setFixed(false)}>
                    <div className="function-checkbox-label-wrapper">
                        <OliverText text="Open cart discount input box" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                        <OliverText text="This will open the cart discount pop up" size="xs" weight="light" translatePrefix="popup.actionBuilder." />
                    </div>
                    <SimpleCheckbox callback={() => {}} checked={!isFixed} label="" value="" custom={false} />
                </div>
                <div className="function-checkbox-wrapper" onClick={() => setFixed(true)}>
                    <div className="function-checkbox-label-wrapper">
                        <OliverText text="Fixed cart discount" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                        <OliverText
                            text="This will automatically add a fixed discount"
                            size="xs"
                            weight="light"
                            translatePrefix="popup.actionBuilder."
                        />
                    </div>
                    <SimpleCheckbox callback={() => {}} checked={isFixed} label="" value="" custom={false} />
                </div>
                {isFixed ? (
                    <div className="function-add-cart-note-wrapper">
                        <TextInput callback={setLabel} value={discountLabel} className="actions-tab-input" placeholder="Discount label" />
                        <TextInput
                            callback={handleAmount}
                            value={discountAmount}
                            className="actions-tab-input"
                            placeholder="Amount"
                            icon={{
                                src: ["./dollar-sign.svg", "./percentage-sign.svg"],
                                callback: (event: React.MouseEvent) => {
                                    event.preventDefault();
                                    handleToggle();
                                }
                            }}
                            isPercent={isPercent}
                        />
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default AddCartDiscount;
